/** @module components/helpers */

/**
 * In place sort of a list of `CMultiSelect` options.
 * Uses the `Array.prototype.sort()` function.
 *
 * @function
 *
 * @param {array} opts has to be a list of options. Each entry has to have a `text` property. Otherwise the `sortByProperty` has to be defined.
 * @param {object} params
 * @param {boolean} params.asc wheather to sort ascending or not.
 * @param {string} params.sortByProperty is the property by which the options should be sorted. The returned value has to be a `string`.
 *
 * @return {array} the sorted options.
 */
export function sortSelectOptions(opts, { asc = true, sortByProperty = 'label' } = {}) {
  return opts.sort((e1, e2) => {
    const c = asc ? 1 : -1
    return c * e1[sortByProperty].localeCompare(e2[sortByProperty], undefined, { numeric: true })
  })
}
